var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.83398 8.66536H3.83398V7.33203H7.83398V3.33203H9.16732V7.33203H13.1673V8.66536H9.16732V12.6654H7.83398V8.66536Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonWhite);
export default __webpack_public_path__ + "static/media/button_white.4d0523ec6200ff9e6647732aa858742e.svg";
export { ForwardRef as ReactComponent };